export default {
  placesCarousel: {
    layer: 'Stratul',
    lat: 'Lat.',
    lon: 'Lon.',
    placeDetails: 'Detalii privind locul',
    next: 'Următorul bloc',
    prev: 'Blocul anterior',
    directionsTo: 'Direcții către',
    distance: 'Distanță',
    notAvailable: 'Nu este disponibil',
    distanceFromLocationMarkedOnTheMap: 'Distanța aproximativă față de locația marcată pe hartă',
    selectPlace: 'Selectați',
  }
}
